 <!-- <main role="main" class="not-home-page">
 <div class="row">
     <div class="col-lg-2 col-md-2 col-xs-12 col-sm-12">
        <app-statique-menu [lg]="outputLg"></app-statique-menu>
     </div>
     <div class="col-lg-8 col-md-8 col-xs-12 col-sm-12">
      <nav aria-label="breadcrumb">
         <ol class="breadcrumb">
           <li class="breadcrumb-item"><a href="javascript:void(0)" [routerLink]="['/']" routerLinkActive="router-link-active" >Accueil</a></li>
           <li class="breadcrumb-item"><a href="javascript:void(0)" [routerLink]="[urlSection]" routerLinkActive="router-link-active">{{section}}</a></li>
           <li class="breadcrumb-item active" >{{titrePage}}</li>
         </ol>
       </nav>
        <div id="content"> 

        </div>
     </div>
     <div class="col-lg-2 col-md-2 col-xs-12 col-sm-12">

     </div>

 </div>

</main> -->

<main role="main" class="not-home-page">
   <div class="row">  
     <div class="container">
        <div class="row" *ngIf="ocpm;else normalPage">
          <div class="col-md-12">
            <div class="banner"><img src="" alt=""></div>
              <app-breadcrumb></app-breadcrumb>           
            <h2>{{titrePage}}</h2>
          </div>
          <div class="col-md-12" style="margin-right: 10px;margin-left: 10px;">       
            <section class="content-side">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <div id="content"> 
                    </div>
                 </div>
              </div>
           </div>
            </section>
           </div>
        </div>
        <ng-template #normalPage>
        <div class="row" >
          <div class="col-md-12">
            <div class="banner"><img src="" alt=""></div>
              <app-breadcrumb></app-breadcrumb>           
            <h2>{{titrePage}}</h2>
          </div>
          <div class="col-md-3 side-bar" style="margin-right: 10px;margin-left: 10px;">
            <div class="selected-item">      </div>   
            <nav id="sidebar">
              <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
            </nav>
          </div>
          <div class="col-md-8" style="margin-right: 10px;margin-left: 10px;">       
            <section class="content-side">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <div id="content"> 
                    </div>
                 </div>
              </div>
           </div>
            </section>
           </div>
        </div>
      </ng-template>
     </div>
  </div>
  </main>